<template>
  <div class="notfound">
    <div class="nofind--main">
      <!-- <p class="font--focus">404</p> -->
      <div class="bruce flex-ct-x">
        <div class="fault-text" data-text="404">404</div>
      </div>
      <p class="font--helper">抱歉，你访问的页面不存在</p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'notfound-404',
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    backHome() {
      this.$router.go(-1)
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.font {
  &--focus {
    margin: 10px 0;
    color: #606266;
    font-size: 72px;
    font-weight: 600;
  }

  &--helper {
    margin: 20px 0;
    color: #909399;
    font-size: 18px;
  }
}
.notfound {
  width: 100%;
  height: 100%;
  display: flex;
  // justify-content: center;
  flex-direction: column;
  margin-top: 10%;
  p {
    text-align: center;
  }
  .nofind--main {
    display: flex;
    // justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
.bruce {
  // background-color: #000;
  height: 111px;
  width: 169px;
}
.fault-text {
  position: relative;
  font-weight: bold;
  font-size: 100px;
  color: #333;
  &::before,
  &::after {
    overflow: hidden;
    position: absolute;
    top: 0;
    // background-color: #000;
    clip: rect(0, 900px, 0, 0);
    color: #333;
    content: attr(data-text);
    animation: shake 3s linear infinite alternate-reverse;
  }
  &::before {
    left: -2px;
    text-shadow: 1px 0 #09f;
  }
  &::after {
    left: 2px;
    text-shadow: -1px 0 #f66;
    animation-duration: 2s;
  }
}
@keyframes shake {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i * (1 / $steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}
</style>
